module.exports = __webpack_public_path__ + "static/media/kitchenmarket_thumb_even.ce1d0a65.jpg";